import tokeys from 'tokeys';

export const TabsManageEmployees = tokeys([
  'employees',
  'massUpload',
  'settings'
]);

export const MANAGE_EMPLOYEES_SEARCH_NAME = 'tab';
export const MANAGE_EMPLOYEES_QUERY_NAME = '?tab=';
